import React, { useId, useState } from 'react';
import { Box, Tab as MuiTab, Tabs as MuiTabs } from '@mui/material';

export const Tab = ({ children }) => children;
export const Tabs = ({ activeKey, defaultActiveKey, onSelect, children, id, className, mountOnEnter, unmountOnExit, transition, ...props }) => {
  const generatedId = useId();
  const baseId = id || generatedId;
  const tabs = React.Children.toArray(children).filter(React.isValidElement);
  const [localKey, setLocalKey] = useState(defaultActiveKey ?? tabs[0]?.props.eventKey);
  const value = activeKey ?? localKey;
  return <Box className={className} {...props}>
    <MuiTabs value={value} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile aria-label="Secciones del formulario"
      onChange={(event, next) => { setLocalKey(next); onSelect?.(next, event); }} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      {tabs.map(tab => <MuiTab key={tab.props.eventKey} value={tab.props.eventKey} label={tab.props.title} disabled={tab.props.disabled}
        id={baseId + '-tab-' + tab.props.eventKey} aria-controls={baseId + '-panel-' + tab.props.eventKey} />)}
    </MuiTabs>
    {tabs.map(tab => <Box key={tab.props.eventKey} role="tabpanel" hidden={value !== tab.props.eventKey}
      id={baseId + '-panel-' + tab.props.eventKey} aria-labelledby={baseId + '-tab-' + tab.props.eventKey}>
      {(!unmountOnExit || value === tab.props.eventKey) && tab.props.children}
    </Box>)}
  </Box>;
};
